module.exports = __webpack_public_path__ + "img/band-small-light.8e9a3826.svg";